export default "__VITE_ASSET__Cbz_cy2v__"